import React from 'react';
import { BaseEdge, EdgeLabelRenderer, getSmoothStepPath } from 'reactflow';
import { Plus } from 'lucide-react';

/**
 * A line between two steps of an eval, with a "+" at its middle that inserts
 * a step on it. The "+" shows while the line (or the "+" itself) is hovered:
 * the canvas tracks which line that is and passes it in `data.hover`.
 *
 * data: { onInsert, hover, keep, drop }
 *   onInsert  inserts a step on this line; absent on a read-only canvas
 *   keep/drop hold or release the hover while the pointer is on the "+",
 *             which sits in its own layer, off the line
 */
export default function InsertEdge({
  id, sourceX, sourceY, targetX, targetY, sourcePosition, targetPosition, style, markerEnd,
  label, labelStyle, labelBgStyle, data,
}) {
  const [path, labelX, labelY] = getSmoothStepPath({ sourceX, sourceY, sourcePosition, targetX, targetY, targetPosition });
  // Under the outcome's name when the line carries one, so the two never overlap.
  const plusY = labelY + (label ? 18 : 0);
  return (
    <>
      <BaseEdge id={id} path={path} style={style} markerEnd={markerEnd} label={label} labelX={labelX} labelY={labelY}
        labelStyle={labelStyle} labelBgStyle={labelBgStyle} interactionWidth={22} />
      {data?.onInsert && (
        <EdgeLabelRenderer>
          <button type="button" className={`eval3-edge-plus nodrag nopan${data.hover ? ' is-shown' : ''}`}
            style={{ transform: `translate(-50%, -50%) translate(${labelX}px, ${plusY}px)` }}
            title="Insert a step here" aria-label="Insert a step here"
            onMouseEnter={() => data.keep?.()} onMouseLeave={() => data.drop?.()}
            onClick={(e) => { e.stopPropagation(); data.onInsert(); }}>
            <Plus size={11} strokeWidth={2} aria-hidden />
          </button>
        </EdgeLabelRenderer>
      )}
    </>
  );
}
